export default __webpack_public_path__ + "static/amazon_flags-0fb82e8b5ecf231a743da9866d761863.svg";